import { CSSProperties, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { Sidebar } from "semantic-ui-react";

// types
import { Page } from "./types";

// pages
import DashboardPage from "containers/dashboard";
// import CategoryPage from "containers/category";
import IntegrationPage from "containers/integration";
import PerformancePage from "containers/performance";
import LoginPage from "containers/loginpage";

// components
import SidebarMenu from "../../components/SidebarMenu";
import TopBarMenu from "../../components/TopBarMenu";
import colors from "assets/colors";
import {
  useClassInfo,
  useInitLocationParams,
  useSchoolInfo,
  useStudentInfo,
} from "hooks";

const Pages: Page[] = [
  {
    component: DashboardPage,
    path: "/:uid",
    name: "歷年表現",
  },
  {
    component: PerformancePage,
    path: "/:uid/performance",
    name: "本學年表現",
  },
  // {
  //   component: CategoryPage,
  //   path: "/category",
  //   name: "範疇細節",
  // },
  {
    component: IntegrationPage,
    path: "/:uid/integration",
    name: "AI 綜合分析",
  },
];

const PageContainerStyle: CSSProperties = {
  height: "100%",
  background: colors.pageBackground,
};

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useSchoolInfo();
  useClassInfo();
  useStudentInfo();
  useInitLocationParams();

  function onSidebarToggle() {
    setSidebarOpen((prev) => !prev);
  }

  return (
    <div style={{ position: "relative", height: "100vh" }}>
      <Sidebar.Pushable>
        <SidebarMenu
          sidebarOpen={sidebarOpen}
          onSidebarToggle={onSidebarToggle}
          pages={Pages}
        />
        <Sidebar.Pusher style={PageContainerStyle}>
          <TopBarMenu onSidebarToggle={onSidebarToggle} pages={Pages} />
          <Switch>
            {Pages.map((page) => (
              <Route
                key={page.path}
                exact
                path={page.path}
                component={page.component}
              />
            ))}
            <Route path="/:uid" component={DashboardPage} />
            <Route path="/" component={LoginPage} />
          </Switch>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </div>
  );
}

export default App;
